export interface MessageToolkitBanner {
  mktBannerIconPath: string;
  mktBannerLabel: string;
  mktBannerMessage: string;
  alertbannerbdrcolor?: string;
  alertbannerbgcolor?: string;
  alertsubheadingdate?: string;
  headerColor: string;
  templateType: string;
  descriptionColor: string;
}
